import _ from 'lodash';
import {Button as AntButton, Modal, Select, Table, TableColumnsType} from 'antd';
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { IGetMessageRead, IMessageRead } from '../../models/messages.model';
import useAxios from '../../hooks/useAxios';
import { getMessageRead } from '../../api/messages.api';
import moment from 'moment';
import config from '../../lib/config';
import Pagination from '../Pagination';

interface IProps {
    visible: boolean;
    setVisible: (visible: boolean) => void;
    messageCode: number;
}

const MessageReadModal = ({visible, setVisible, messageCode}: IProps) => {
    
    const { t, i18n } = useTranslation();
    const {data: messageReadRes, isLoading, error, execute,} = useAxios<IGetMessageRead>();
    const [page, setPage] = useState(1);
    const [readCnt, setReadCnt] = useState(0);
    const [unReadCnt, setUnReadCnt] = useState(0);

    useEffect(() => {
        onSearch();
    }, []);

    useEffect(() => {
        if (messageReadRes && !isLoading) {
            let tempMessageReadList : IMessageRead[]  = _.cloneDeep(messageReadRes.data);

            if (tempMessageReadList.length > 0) {

                let tempReadCnt = 0;
                let tempUnReadCnt = 0;

                tempMessageReadList.forEach((item: IMessageRead) => {
                    if(item.readYn === 'Y') {
                        tempReadCnt++;
                    } else {
                        tempUnReadCnt++;
                    }
                });

                setReadCnt(tempReadCnt);
                setUnReadCnt(tempUnReadCnt);
            }
        }
    }, [messageReadRes, isLoading]);
    
    const onSearch = () => {
        execute(getMessageRead(messageCode));
    }
    
    const columns: TableColumnsType<IMessageRead> = [
        {
            title: t('message.archive.column3'),
            dataIndex: 'memberName',
            key: 'memberName',
            align: 'center',
            render: (value, record) => {
                return (value + '(' + record.memberEngName + ')');
            } 
        },
        {
          title: t('message.archive.column7'),
          dataIndex: 'readYn',
          key: 'readYn',
          align: 'center',
          render: (value) => (value === 'Y' ? t('message.archive.text2') : t('message.archive.text3'))
        },
        {
          title: t('message.archive.column8'),
          dataIndex: 'readDatetime',
          key: 'readDatetime',
          align: 'center',
          render: (value) => value != null ? moment(value).format('YYYY-MM-DD HH:mm') : ''
        },
    ];    

    return (
        <Modal
            title={t('message.archive.button2')}
            width={600}
            open={visible}
            onCancel={() => setVisible(false)}
            footer={[
            <div className='comm-btn__area justify-content-center'>
                <AntButton key="cancel" className='btn-basic gray' onClick={() => setVisible(false)}>
                {t('common.button.close')}
                </AntButton>
            </div>
            ]}
        >
            <div>
                <div className="comm-bx__space">
                    {t('message.archive.button2') + '(' + t('message.archive.text2') + ' : ' + readCnt + ' / '+ t('message.archive.text3') + ' : ' + unReadCnt + ')'}
                </div>
                <div className='comm-table__area mt-0'>
                    <Table
                        columns={columns}
                        dataSource={messageReadRes?.data || undefined}
                        pagination={{
                            current: page,
                            pageSize: config.smallPageSize,
                        }}
                        rowKey={'no'}
                    />
                </div>
                <div className="comm-bx__between">
                    <div className="common-paging center">
                        <Pagination count={messageReadRes?.data?.length || 0} page={page} setPage={setPage} perPage={config.smallPageSize}  />
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default MessageReadModal;